/**
 * `marg.telemetry` (GDD C190) — orchestrator override: an IN-MEMORY ring of 5 000 local events instead of the
 * IndexedDB ring. Export only, never sent anywhere. Every bus notification is recorded; features may add their own
 * events through `track()` (combat §15.3 and monetization §13 names). Exposed as `__marg.telemetry.{events, export}`.
 */
import type { EventBus, GameEvents } from '../shared';

export interface TelemetryEvent { t: number; name: string; data?: unknown }

export const TELEMETRY_RING = 5000;

/** Every `GameEvents` key (the bus has no wildcard subscription). */
const BUS_EVENTS: ReadonlyArray<keyof GameEvents> = ['app/screen', 'app/saved', 'app/visibility', 'creature/changed', 'combat/fightStarted',
  'combat/fightEnded', 'explore/chronicle', 'explore/questDone', 'cards/matchEnded', 'meta/granted', 'meta/levelUp', 'ui/toast'];

export class Telemetry {
  private readonly ring: TelemetryEvent[] = [];
  constructor(private readonly now: () => number, private readonly size = TELEMETRY_RING) {}

  track(name: string, data?: unknown): void {
    this.ring.push({ t: this.now(), name, data });
    if (this.ring.length > this.size) this.ring.splice(0, this.ring.length - this.size);
  }

  /** The last n events (default all), oldest first. */
  events(n?: number): TelemetryEvent[] { return n === undefined ? this.ring.slice() : this.ring.slice(Math.max(0, this.ring.length - n)); }

  /** JSON export (Settings «Скопировать диагностику», ui-ux A48 sessions). */
  export(): string { return JSON.stringify({ format: 'marg-telemetry', v: 1, events: this.ring }); }

  /** Records every bus notification. Returns the unsubscribe function. */
  listen(bus: EventBus<GameEvents>): () => void {
    const offs = BUS_EVENTS.map((k) => bus.on(k, (p) => this.track(k, p)));
    return () => { for (const off of offs) off(); };
  }
}
